import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { Loading } from './common/Loading';

const PrivateRoute = () => {
  const { user, loading } = useContext(AuthContext);
  
  if (loading) {
    return <Loading />; // ✅ CRITICAL: Add 'return' statement!
  }
  
  return user ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;